module.exports = __webpack_public_path__ + "img/RPalintonon64_ua.4f276566.webp";